module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "col-xs-12 main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-9 col-lg-10 slots"
  }, [_c('div', {
    staticClass: "dashboard-header"
  }, [_c('h2', [_vm._v("Agents: Availability")])]), _vm._v(" "), (_vm.slots && !_vm.isEmpty) ? _c('div', {
    staticClass: "summary"
  }, [_vm._l((_vm.summary.types), function(t) {
    return _c('span', {
      key: t.type,
      staticClass: "summary-card",
      attrs: {
        "title": t.total + ' agent-slots available over ' + _vm.summary.days + ' days'
      }
    }, [_c('span', {
      staticClass: "label",
      class: _vm.labelClass(t.type)
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.iconClass(t.type)
    })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(t.total))]), _vm._v(" " + _vm._s(t.label) + "\n        ")])
  }), _vm._v(" "), _c('span', {
    staticClass: "summary-card metric"
  }, [_c('strong', [_vm._v(_vm._s(_vm.summary.days))]), _vm._v(" days")]), _vm._v(" "), _c('span', {
    staticClass: "summary-card metric",
    attrs: {
      "title": "Most agents available for one appointment type in a single slot"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.summary.peak))]), _vm._v(" peak"), (_vm.summary.peakTime) ? _c('span', {
    staticClass: "muted"
  }, [_vm._v(" @ " + _vm._s(_vm.summary.peakTime))]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.slots) ? _c('div', {
    staticClass: "panel stats"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.isEmpty) ? _c('div', {
    staticClass: "text-center no-data"
  }, [_vm._v("\n              No availability found for the selected agents.\n            ")]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table slots-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.slots.header), function(column, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(column))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.hours), function(hour) {
    return _c('tr', {
      key: hour
    }, [_c('th', [_vm._v(_vm._s(hour))]), _vm._v(" "), _vm._l((_vm.days), function(day, index) {
      return _c('td', {
        key: index
      }, _vm._l((_vm.cellTypes(hour, day)), function(count, type) {
        return _c('span', {
          key: type,
          staticClass: "label",
          class: _vm.labelClass(type),
          attrs: {
            "title": _vm.appointmentTypeLabels[type]
          }
        }, [_c('i', {
          staticClass: "fa",
          class: _vm.iconClass(type)
        }), _vm._v(" " + _vm._s(count) + "\n                      ")])
      }), 0)
    })], 2)
  }), 0)])])])]) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters),
      expression: "filters"
    }],
    staticClass: "col-xs-12 col-md-3 col-lg-2"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters,
      "renderSearch": false
    },
    on: {
      "applyFilters": _vm.applyFilters
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(!_vm.loaded) ? _c('loading-modal') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c7783f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/AgentSlots.vue
// module id = 655
// module chunks = 0